// Backward-compatible TrainerCard wrapper
import { ProfessionalCard } from "@/components/professionals/ProfessionalCard";

interface TrainerCardProps {
  id: string;
  slug?: string;
  fullName: string;
  locationCity: string;
  locationCountry: string;
  specialty: string | string[];
  yearsExperience: number;
  hourlyRate: number;
  bio: string;
  profileImage?: string;
  subscriptionType?: string;
  source?: 'profile' | 'listing';
}

export const TrainerCard = ({ source, ...props }: TrainerCardProps) => (
  <ProfessionalCard {...props} type="trainer" source={source} />
);
